import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { hasActiveSession } from 'utils/session';

import type { Dispatch, UnreadConversation, UnreadMessages } from 'types';

const RECEIVE_AGGREGATED_UNREAD_CONVERSATIONS = 'unreadMessage/RECEIVE_AGGREGATED_UNREAD_CONVERSATIONS';

const initialState: UnreadMessages = {
  conversations: [],
  totalUnreadConversations: 0
};

function receiveUnreadConversations(conversations: Array<UnreadConversation>, totalUnreadConversations: number) {
  return {
    type: RECEIVE_AGGREGATED_UNREAD_CONVERSATIONS,
    payload: {
      conversations,
      totalUnreadConversations
    }
  };
}

export function fetchGroupedUnreadConversations(organizationId: number) {
  const url = `${API.END_POINTS.MESSENGER.getUnreadMessages()}?organization_id=${organizationId}`;

  return async (dispatch: Dispatch): Promise<void> => {
    if (!hasActiveSession()) {
      dispatch(receiveUnreadConversations([], 0));

      return;
    }

    try {
      const { data } = await get(url, {
        headers: {
          accept: 'application/version2+json'
        }
      });

      dispatch(receiveUnreadConversations(data.conversations, data.totalUnreadConversations));
    } catch (error) {
      logError(error);
    }
  };
}

export default createReducer<UnreadMessages, any>('unreadMessages', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RECEIVE_AGGREGATED_UNREAD_CONVERSATIONS]: (state, { conversations, totalUnreadConversations }) => ({
    ...state,
    conversations,
    totalUnreadConversations
  })
});
